module.exports = __webpack_public_path__ + "img/hh6.515ed5a0.png";